import React from 'react'
import { Link } from 'react-router-dom'
import SEO from '../common/SEO'
import HeaderKorlo from '../common/header/HeaderKorlo'
import AboutKorlo from '../elements/accordion/AboutKorlo.json'
import { FiArrowRight } from 'react-icons/fi'

const KorloAboutPage = () => {
  return (
    <>
      <SEO title='About - Korlo AI' />
      <main className='page-wrapper'>
        <HeaderKorlo btnStyle='btn-small' />

        {/* About Hero */}
        <section className='korlo-about-hero'>
          <div className='container'>
            <span className='about-label'>About Us</span>
            <h1 className='about-title'>Pioneering AI-Powered<br />Language Education</h1>
            <p className='about-subtitle'>
              Korlo AI is building the next generation of language learning platforms
              by harnessing large language models and data analytics.
            </p>
          </div>
        </section>

        {/* About Content */}
        <section className='korlo-about-content'>
          <div className='container'>
            <div className='row justify-content-center'>
              <div className='col-lg-8'>
                {AboutKorlo.map((item, index) => (
                  <div key={index} className='about-block'>
                    <span className='about-block-number'>0{index + 1}</span>
                    <h3 className='about-block-title'>{item.title}</h3>
                    <div className='about-block-text'>
                      {item.text.map((value, i) => (
                        <div key={i} dangerouslySetInnerHTML={{ __html: value }} />
                      ))}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* CTA */}
        <section className='korlo-cta'>
          <div className='container'>
            <div className='cta-inner'>
              <h2 className='cta-title'>Want to Learn More?</h2>
              <p className='cta-text'>
                We'd love to hear from you. Reach out to learn more about
                what we're building at Korlo AI.
              </p>
              <Link to='/contact' className='btn-primary-korlo'>
                Contact Us <FiArrowRight />
              </Link>
            </div>
          </div>
        </section>

        {/* Footer */}
        <footer className='korlo-footer'>
          <div className='container'>
            <div className='footer-inner'>
              <span className='footer-copyright'>
                &copy; {new Date().getFullYear()} Korlo Holdings LLC
              </span>
              <div className='footer-links'>
                <Link to='/about'>About</Link>
                <Link to='/contact'>Contact</Link>
              </div>
            </div>
          </div>
        </footer>
      </main>
    </>
  )
}

export default KorloAboutPage
